export const USER_DETAILS_LISTING_COLUMNS = [
  {
    id: "employeeId",
    label: "User Code",
  },
  {
    id: "firstName",
    label: "Name",
  },
  {
    id: "email",
    label: "Email",
  },
  {
    id: "deptName",
    label: "Department",
  },
  {
    id: "roleName",
    label: "Role",
  },
  {
    id: "active",
    label: "Status",  
  },
  {
    id: "lock",
    label: "",     
  },
  {
    id: "action",    
    label: "Action",
  },
];

export const PRODUCT_CATEGORY_DETAILS_LISTING_COLUMNS = [
  {
    id: "categoryCode",
    label: "Category Code",
  },
  {
    id: "categoryName",
    label: "Category Name",
  },
  {
    id: "active",
    label: "Status",
  },
  {
    id: "action",
    label: "Action",
  },
];

export const DEPARTMENTS_DETAILS_LISTING_COLUMNS = [
  {
    id: "departmentId",
    label: "Department Code",
  },
  {
    id: "name",
    label: "Department Name",
  },
  {
    id: "active",
    label: "Status",
  },
  {
    id: "action",
    label: "Action",
  },
];

export const PRODUCT_FAMILY_DETAILS_LISTING_COLUMNS = [
  {
    id: "productFamilyName",
    label: "Family Name",
  },
  {
    id: "categoryName",
    label: "Category Name",
  },
  {
    id: "active",
    label: "Status",
  },
  {
    id: "action",
    label: "Action",
  },
];

export const FUNCTION_DETAILS_LISTING_COLUMNS = [
  {
    id: "name",
    label: "Function Name",
  },
  {
    id: "functionCode",
    label: "Function Code",
  },
  {
    id: "Dname",
    label: "Department Name",
  },
  {
    id: "active",
    label: "Status",
  },
  {
    id: "action",
    label: "Action",
  },
];

export const PRODUCT_BRICK_DETAILS_LISTING_COLUMNS = [
  {
    id: "brickName",
    label: "Brick Name",
  },
  {
    id: "brickCode",
    label: "Brick Code",
  },
  {
    id: "categoryName",
    label: "Category Name",
  },
  {
    id: "productFamilyName",
    label: "Family Name",
  },
  {
    id: "active",
    label: "Status",
  },
  {
    id: "action",
    label: "Action",
  },
];

export const BRAND_DETAILS_LISTING_COLUMNS = [
  {
    id: "brandName",
    label: "Brand Name",
  },
  {
    id: "categoryName",
    label: "Product Category",
  },
  {
    id: "productFamilyName",
    label: "Product Family",
  },
  {
    id: "brickName",
    label: "Product Brick",
  },
  {
    id: "active",
    label: "Status",
  },
  {
    id: "action",
    label: "Action",
  },
];

export const MODEL_LISTING_COLUMNS = [
  {
    id: "brandName",
    label: "Brand Name",
  },
  {
    id: "productFamilyName",
    label: "Product Family",
  },
  {
    id: "brickName",
    label: "Brick Name",
  },
  {
    id: "modelName",
    label: "Model Name",
  },
  {
    id: "modelDesc",
    label: "Model Description",
  },
  {
    id: "active",
    label: "Status",
  },
  {
    id: "",
    label: "",
  },
];

export const SUPPLIER_AND_VENDOR_LISTING_COLUMNS = [
  {
    id: "code",
    label: "User Code",
  },
  {
    id: "name",
    label: "Name",
  },
  {
    id: "typeName",
    label: "Type",
  },
  {
    id: "active",
    label: "Status",
  },
  {
    id: "action",
    label: "Action",
  },
];

export const PART_TYPE_LISTING_COLUMNS = [
  {
    id: "partTypeCode",
    label: "Code",
  },
  {
    id: "name",
    label: "Name",
  },

  {
    id: "active",
    label: "Status",
  },
  {
    id: "action",
    label: "Action",
  },
];

export const SPARE_LISTING_COLUMNS = [
  {
    id: "code",
    label: "Article Code",
  },
  {
    id: "spareDescription",
    label: "Description",
  },
  {
    id: "brandName",
    label: "Brand Name",
  },
  {
    id: "brickName",
    label: "Brick Name",
  },
  {
    id: "partName",
    label: "Part Name",
  },
  {
    id: "defSpareActionName",
    label: "Action Plan",
  },
  {
    id: "hasAlternateSpare",
    label: "Alternate",
  },
  {
    id: "active",
    label: "Status",
  },
  {
    id: "",
    label: "",
  },
];

export const SPARES_BY_MODEL_ID_LISTING_COLUMNS = [
  {
    id: "code",
    label: "Article Code",
  },
  {
    id: "spareDescription",
    label: "Article Description",
  },
  {
    id: "partName",
    label: "Part Name",
  },
  {
    id: "warranty",
    label: "Spare Warranty",
  },
  {
    id: "billingPr",
    label: "Billing Price",
  },
  {
    id: "retailPr",
    label: "Retail Price",
  },
  {
    id: "defSpareActionName",
    label: "Spare Action",
  },
  {
    id: "hasAlternateSpare",
    label: "Alternate",
  },
  {
    id: "noOfElements",
    label: "Alternate Spares",
  },
  {
    id: "",
    label: "",
  },
];

export const SPARES_BY_SPARE_ID_LISTING_COLUMNS = [
  {
    id: "code",
    label: "Article Code",
  },
  {
    id: "description",
    label: "Spare Article Description",
  },
  {
    id: "brandName",
    label: "Brand Name",
  },
  {
    id: "brickName",
    label: "Brick Name",
  },
  {
    id: "partName",
    label: "Part Name",
  },
  {
    id: "defSpareActionName",
    label: "Defective Spare Action",
  },
  {
    id: "action",
    label: "Action",
  }
];

export const TECHNICAL_DOCUMENT_LISTING_COLUMNS = [
  {
    id: "techDocDesc",
    label: "Doc Desc.",
  },
  {
    id: "name",
    label: "Model",
  },
  {
    id: "brandName",
    label: "Brand",
  },
  {
    id: "categoryName",
    label: "Category",
  },
  {
    id: "productFamilyName",
    label: "Family",
  },
  {
    id: "brickName",
    label: "Brick",
  },
  {
    id: "description",
    label: "Doc Type",
  },
  {
    id: "createdByFirstName",
    label: "Owner",
  },
  {
    id: "active",
    label: "Status",
  },
  {
    id: "action",
    label: "Action",
  },
];

export const SERVICE_ADVISORY_LISTING_COLUMNS = [
  {
    id: "advisoryNumber",
    label: "Advisory",
  },
  {
    id: "brandName",
    label: "Brand",
  },
  {
    id: "categoryName",
    label: "Category",
  },
  // {
  //   id: "productFamilyName",
  //   label: "Family",
  // },
  // {
  //   id: "brickName",
  //   label: "Brick",
  // },
  {
    id: "name",
    label: "Model",
  },
  // {
  //   id: "docTypeDescription",
  //   label: "Type",
  // },
  {
    id: "createdByFirstName",
    label: "Owner",
  },
  {
    id: "releaseDate",
    label: "Release Date",
  },
  {
    id: "active",
    label: "Status",
  },
  {
    id: "action",
    label: "Action",
  },
];

export const MODELS_BY_SPARE_ID_LISTING_COLUMNS = [
  {
    id: "modelName",
    label: "Model Name",
  },
  {
    id: "code",
    label: "Article Code",
  },
  {
    id: "modelDescription",
    label: "Model Description",
  },
  {
    id: "brandName",
    label: "Brand Name",
  },
  {
    id: "brickName",
    label: "Brick Name",
  },
  {
    id: "partName",
    label: "Part Name",
  },
  {
    id: "defSpareActionName",
    label: "Defective Spare Action",
  },
];

export const VENDORS_BY_SPARE_ID_LISTING_COLUMNS = [
  {
    id: "vcode",
    label: "Code",
  },
  {
    id: "name",
    label: "Name",
  },
  {
    id: "repair",
    label: "Repair",
  },
  {
    id: "active",
    label: "Status",
  },
];
